import { IForecastMaterialsState } from '../interfaces/forecastMaterialsState';

type WithForecastMaterialsState = {
  ForecastMaterialSlice: IForecastMaterialsState;
};
export const ForecastMaterialsStateSelector = (
  state: WithForecastMaterialsState,
): IForecastMaterialsState => state.ForecastMaterialSlice;
